import { render, staticRenderFns } from "./AgentTransactionsReportTrademarkSearchList.vue?vue&type=template&id=4389600a&"
import script from "./AgentTransactionsReportTrademarkSearchList.vue?vue&type=script&lang=js&"
export * from "./AgentTransactionsReportTrademarkSearchList.vue?vue&type=script&lang=js&"
import style0 from "./AgentTransactionsReportTrademarkSearchList.vue?vue&type=style&index=0&id=4389600a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports